import Swal from 'sweetalert2'

export default {
  successfulLogin () {
    Swal.fire({
      title: 'Du är inloggad!',
      icon: 'success',
      position: 'center',
      timer: 1000,
      showConfirmButton: false
    })
  },

  failureLogin () {
    Swal.fire({
      title: 'Inloggningen misslyckades',
      text: '',
      icon: 'error',
      timer: 1000,
      showConfirmButton: false
    })
  },

  failureRegistration (error) {
    Swal.fire({
      title: 'Registeringen misslyckades!',
      text: this.userErrorMessage(error),
      icon: 'error',
      showConfirmButton: true
    })
  },

  failedOperation (error) {
    Swal.fire({
      title: 'Operationen misslyckades!',
      text: error,
      icon: 'error',
      showConfirmButton: false
    })
  },

  errorMessage (title, text) {
    Swal.fire({
      title: title,
      text: text,
      icon: 'error',
      showConfirmButton: true
    })
  },

  successMessage (title) {
    Swal.fire({
      title: title,
      text: '',
      icon: 'success',
      timer: 3000,
      showConfirmButton: true
    })
  },

  userErrorMessage (error) {
    let errorString = ''
    if (error.username) {
      errorString += 'Användarnamn: ' + error.username
    }
    if (error.password) {
      errorString += ' Lösenord: ' + error.password
    }
    if (error.confirm_password) {
      errorString += ' Bekräfta Lösenord: ' + error.confirm_password
    }
    if (error.email) {
      errorString += ' E-post: ' + error.email
    }
    return errorString
  }
}
